import { AfterViewInit, Component, NgZone, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { NgwWowService } from 'ngx-wow';
import { combineLatest, Observable, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import * as GlobalActions from "./core/state/global/global.action";
import * as AdsActions from "./core/state/ads/ads.action";
import * as PartnerBrandingActions from "./core/state/partner-branding/partner-branding.action";
import { getPartnerBranding } from "./core/state/partner-branding";
import { IPartnerBranding } from './core/domain/partner-branding.model';
import * as NotificationsActions from "./core/state/notifications/notifications.action";
import * as ProfileActions from "./core/state/profile/profile.action";
import { getLoggedInUser } from './core/state/auth';
import { Auth, CorporateProfileCompleteness, InvestorProfileCompleteness, MentorProfileCompleteness, ServiceProviderProfileCompleteness, StartupProfileCompleteness } from './core/domain';
import { IGlobalSettings } from './core/domain/settings.model';
import { getBrandDetails, getGlobalSettings, getGlobalSettingsError } from './core/state/global';
import { Meta } from "@angular/platform-browser";
import { MixpanelService } from './core/service/mixpanel.service';
import { TenantService } from './core/service/tenant.service';
import { ToastAlertService } from './shared/utils/toast.service';
import { FormManagementService } from './core/service/form-management.service';
import { getProfileData } from './core/state/profile';
import { IProfileDetails } from './core/domain/profile.model';
import { IBrandDetails } from './core/domain/brand.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RateExpirenceModalComponent } from './shared/common-components/rate-expirence-modal/rate-expirence-modal.component';
import { SocketService } from './core/service/socket.service';
import { ProfileService } from './core/service/profile.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StorageService } from './shared/utils/storage.service';
import { AutoApplyProgramOffSecret } from './shared/constants/constants';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from 'src/environments/environment';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
declare const gtag: Function;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  title = 'sanchiconnect-frontend-angular';
  private wowSubscription!: Subscription;
  faqs: any;
  public getLoggedInUserDetails$: Observable<Auth>;
  private destroyed$: Subject<void> = new Subject();
  public globalSettings$: Observable<IGlobalSettings>;
  globalSettings: IGlobalSettings;
  tenantLoading = true;
  tenantError = '';
  public getProfileData$: Observable<IProfileDetails>;
  profileData: IProfileDetails;
  // SAN-1490: user the socket was last (re)handshaken for.
  private socketUserId: number | null = null;
  brandDetails: Partial<IBrandDetails>;
  notificationsCountInterval = null;
  maintainanceMode = false;
  subscriptionActive = true;
  showInstallPrompt = false;
  /* SAN-1140: dozens of already-fixed Sentry errors (ngx-ui-loader dupe,
     dashboard-v2 userType, handleDurationChange, mobileNumber, ...) kept
     re-firing in production because ServiceWorkerModule was registered
     with nothing ever calling SwUpdate to detect/apply a new version --
     PWA clients (esp. iOS "Add to Home Screen") can run an arbitrarily old
     cached bundle indefinitely. This mirrors the existing showInstallPrompt
     banner pattern: non-intrusive, dismissible, user-triggered reload
     rather than a silent mid-session reload that could drop form input. */
  showUpdatePrompt = false;
  isIos = false;
  isStandalone = false;
  private deferredPrompt: any;
  private tenantReady = false;
  profileCompleteness: StartupProfileCompleteness | MentorProfileCompleteness | InvestorProfileCompleteness | CorporateProfileCompleteness | ServiceProviderProfileCompleteness;

  constructor(
    private router: Router, private wowService: NgwWowService,
    private route: ActivatedRoute,
    private tenantService: TenantService,
    private toastService: ToastAlertService,
    private formsManagementService: FormManagementService,
    private socketService: SocketService,
    private profileService: ProfileService,
    private modalService: NgbModal,
    private deviceService: DeviceDetectorService,
    private http: HttpClient,
    private swUpdate: SwUpdate,
    private store: Store, private renderer: Renderer2, private metaService: Meta, private mixPanel: MixpanelService, private ngZone: NgZone) {

    window.isMobile = this.deviceService.isMobile();
    window.isTablet = this.deviceService.isTablet();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (this.globalSettings?.site?.google_analytics) {
        gtag('event', 'page_view', {
          page_path: event.urlAfterRedirects
        })
      }
    });


    localStorage.removeItem('inviteData')
    localStorage.removeItem('inviteCode')
    localStorage.removeItem('partner')


    this.route.queryParamMap.subscribe((query) => {
      if (query) {
        let referralCode = query.get('referralCode');
        if (referralCode) {
          localStorage.setItem('referralCode', referralCode)
        }
      }
    })


    this.route.queryParamMap.subscribe((query) => {
      if (query) {
        let program = query.get('program');
        if (program) {
          localStorage.setItem('program', program)
          const autoapply = query.get(StorageService.storageKeys.autoApplyProgram);
          if (autoapply === AutoApplyProgramOffSecret) {
            localStorage.setItem(StorageService.storageKeys.autoApplyProgram, AutoApplyProgramOffSecret)
          } else {
            localStorage.removeItem(StorageService.storageKeys.autoApplyProgram)
          }
        }
        let userType = query.get('userType');
        if (userType) {
          localStorage.setItem('userType-register', userType)
        } else {
          localStorage.removeItem('userType-register')
        }

        let inviteCode = query.get('inviteCode');
        if (inviteCode) {
          localStorage.setItem('inviteCode', inviteCode)
        }
        let partner = query.get('partner');
        if (partner) {
          localStorage.setItem('partner', partner)
        }

        let ratingModal = query.get('rating-modal')
        if (ratingModal) {
          const modal = this.modalService.open(RateExpirenceModalComponent, { size: 'md', scrollable: true, centered: true })
          modal.componentInstance.title = 'Rate your call experience'
        }
      }
    })
    this.profileService.profileCompleteness$
      .pipe(distinctUntilChanged(), takeUntil(this.destroyed$))
      .subscribe((profileCompleteness) => {
        if (profileCompleteness) {
          this.profileCompleteness = profileCompleteness;

          this.formsManagementService.getFormsList(this.profileData?.accountType).subscribe((res) => { })

        }
      })

    this.getLoggedInUserDetails$ = this.store.pipe(select(getLoggedInUser));

    this.store.pipe(select(getProfileData)).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
      if (res) {
        this.profileData = res;
        // console.log('this.profileData --->',this.profileData)

        // SAN-1490: when the logged-in user appears or changes (e.g. in-app
        // login after the socket was opened anonymously), re-handshake so the
        // socket is authenticated before setSocketListners() re-joins the room.
        if (res.id !== this.socketUserId) {
          this.socketUserId = res.id;
          this.socketService.reconnect();
        }

        this.store.pipe(select(getBrandDetails)).pipe(distinctUntilChanged()).subscribe((bRes) => {
          if (bRes) {
            setTimeout(() => {
              this.store.dispatch(new ProfileActions.GetProfileTypes())
              if (bRes.features.connections) {
                this.store.dispatch(new GlobalActions.GetBasicConnectionsList())
              }
            }, 2000)


            window.addEventListener("storage", this.storageEventListner);

            // this.socketService.sendMessage('hllloo');

            this.setSocketListners()
          }
        })
      } else {
        this.socketUserId = null;
        if (this.notificationsCountInterval) {
          clearInterval(this.notificationsCountInterval);
        }
        window.removeEventListener("storage", this.storageEventListner);
      }
    })

    this.store.pipe(select(getBrandDetails)).pipe(distinctUntilChanged()).subscribe((res) => {
      if (res) {
        this.brandDetails = res
        window.brandDetails = res;
        if (this.brandDetails.maintenance_mode?.maintenance_on) {
          this.maintainanceMode = true
        }

        this.subscriptionActive = this.brandDetails.subscription_active
      }
    })

  }

  storageEventListner(event) {
    if (event.key === 'profile' || event.key === 'user') {
      let localProfile: any = localStorage.getItem('profile')
      if (localProfile) {
        localProfile = JSON.parse(localProfile);
      } else {
        setTimeout(() => {
          window.location.href = '/'
        }, 3000)
      }
      if (this.profileData?.uuid !== localProfile?.uuid) {
        setTimeout(() => {
          window.location.href = '/'
        }, 3000)
      }
    }
  }

  updateFavicon(faviconUrl: string) {
    const head = document.getElementsByTagName('head')[0];
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = 'image/x-icon';
    favicon.href = faviconUrl;
    head.appendChild(favicon);
  }

  updateManifest(settings: IGlobalSettings) {
    const iconBaseUrl = settings.imgKitUrl + settings.branding.favicon;
    const manifest = {
      name: settings.branding.brandName || settings.websiteName,
      short_name: settings.branding.brandName || settings.websiteName,
      theme_color: settings.branding.colors.primary || '#1976d2',
      background_color: '#ffffff',
      display: 'standalone',
      scope: location.origin + '/',
      start_url: location.origin + '/',
      icons: [48, 72, 96, 128, 144, 152, 192, 256, 384, 512].map(size => ({
        src: `${iconBaseUrl}?tr=w-${size},h-${size},cm-pad_resize`,
        sizes: `${size}x${size}`,
        type: 'image/png',
        purpose: 'maskable any'
      }))
    };
    const blob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
    const manifestUrl = URL.createObjectURL(blob);
    const manifestLink = document.querySelector('link[rel="manifest"]');
    if (manifestLink) {
      manifestLink.setAttribute('href', manifestUrl);
    }
  }

  updateThemeColor(settings: IGlobalSettings) {
    const themeMetaTag = document.querySelector('meta[name="theme-color"]');
    if (themeMetaTag) {
      themeMetaTag.setAttribute('content', settings.branding.colors.primary || '#1976d2');
    }
  }

  installApp() {
    console.log('PWA: installApp clicked, deferredPrompt:', !!this.deferredPrompt);
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((result: any) => {
        console.log('PWA: user choice:', result.outcome);
        this.showInstallPrompt = false;
        this.deferredPrompt = null;
      });
    }
  }

  dismissInstallPrompt() {
    this.showInstallPrompt = false;
    localStorage.setItem('pwa_install_dismissed', 'true');
  }

  ngAfterViewInit() {
    // this.hideAppLoader();
  }

  hideAppLoader() {
    /* SC-SAAS-FRONTEND-GR / GQ (SAN-1666) -- selectRootElement() throws "The selector #pageLoader did
       not match any elements" when the splash div from index.html is already gone; hide it only if
       it is still there. */
    const loader = document.getElementById('pageLoader');
    if (loader) {
      this.renderer.setStyle(loader, 'display', 'none');
    }
  }

  ngOnInit() {
    this.listenForInstallPrompt();
    this.listenForAppUpdates();
    // this.getIP();
    this.getTenantDetails()
  }

  /* SAN-1140: without this, a new deploy never reaches a tab/PWA instance
     that's already open -- the new service-worker version sits "pending"
     until the user does a full close+reopen, which iOS "Add to Home
     Screen" users especially never do. registerWhenStable already fetches
     new versions in the background; this just surfaces VERSION_READY so
     the user can opt into picking it up instead of silently never getting it. */
  listenForAppUpdates() {
    if (!this.swUpdate.isEnabled) {
      return;
    }
    this.swUpdate.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => {
        this.ngZone.run(() => {
          this.showUpdatePrompt = true;
        });
      });
  }

  reloadForUpdate() {
    document.location.reload();
  }

  dismissUpdatePrompt() {
    this.showUpdatePrompt = false;
  }

  listenForInstallPrompt() {
    const dismissed = localStorage.getItem('pwa_install_dismissed');

    // Android Chrome - beforeinstallprompt
    window.addEventListener('beforeinstallprompt', (e: any) => {
      e.preventDefault();
      this.ngZone.run(() => {
        this.deferredPrompt = e;
        if (!dismissed) {
          this.showInstallPrompt = true;
        }
      });
    });

    // iOS Safari - no beforeinstallprompt support, show manual guide
    const ua = window.navigator.userAgent;
    this.isIos = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    this.isStandalone = ('standalone' in (window.navigator as any)) && (window.navigator as any).standalone;

    if (this.isIos && !this.isStandalone && !dismissed) {
      this.showInstallPrompt = true;
    }
  }

  setSocketListners() {
    if (this.socketService.url && this.profileData) {
      this.socketService.listenToRoom('' + this.profileData.id as any).subscribe((chat) => {
        if (chat) {
          this.store.dispatch(new NotificationsActions.SetNotificationsCount());
        }
      });
    }
  }

  getLocation(ip) {
    fetch(`https://ipapi.co/${ip}/json/`)
      .then(res => res.json())
      .then(loc => {
        console.log('Location:', loc);
        localStorage.setItem('userLocation', JSON.stringify({
          city: loc.city, region: loc.region, country: loc.country_name,
        }));
      })
      .catch(err => console.error('Location fetch failed:', err));
  }
  getTenantDetails() {
    this.tenantService.getTenantDetails().subscribe((res) => {
      this.tenantLoading = false;
      if (res.data) {
        // updateManifest is called later in initiateApp after global settings load
        // ApiEndpointService.setApiEndPoint() itself now runs in TenantService's
        // tap(), before SetBrandDetails is dispatched (SAN-219) - DOMAIN is
        // already correct by the time this callback runs.
        this.socketService.setUrl(res.data.apiUrl);
        // ApiEndpointService.setApiEndPoint('https://api.thub.sanchidev.in/');
        // this.socketService.setUrl('https://api.thub.sanchidev.in/');
        this.setSocketListners()
        // SAN-384/386 — spoke-subdomain branding. Dispatched HERE, not from
        // TenantService, because `GET partner-branding/:abbreviation` lives on
        // the tenant's own backend: it is only addressable after the line above
        // has re-pointed ApiEndpointService at `res.data.apiUrl`. No-op for
        // every hub hostname (`partnerAbbreviation` absent), and a failed call
        // (the normal case until sc-saas-backend's SAN-387 route ships) leaves
        // the tenant-wide branding untouched.
        if (res.data.partnerAbbreviation) {
          this.store.dispatch(new PartnerBrandingActions.GetPartnerBranding(res.data.partnerAbbreviation));
        }
        this.initiateApp();
        this.tenantReady = true;
      }
      this.hideAppLoader();
    }, err => {
      console.log('Tenant errr', err)
      this.tenantLoading = false;
      this.hideAppLoader();
      this.tenantError = err.error?.message || err.message;
      // this.toastService.showToast(this.tenantError || 'Tenant not found', 'error')

      // Tenant verification is the app's bootstrap step - a failure here
      // means the whole site is unusable for this visitor. Guarded to
      // production only, and behind a fixed tag+fingerprint so every
      // occurrence (any hostname) groups into ONE Sentry issue instead of
      // one per visitor - that issue is what the "tenant verification down"
      // Sentry alert rule watches, not individual events.
      if (environment.production) {
        Sentry.captureMessage(`Tenant verification failed: ${this.tenantError || 'unknown error'}`, (scope) => {
          scope.setLevel('fatal');
          scope.setTag('alert', 'tenant-verification-down');
          scope.setFingerprint(['tenant-verification-down']);
          scope.setContext('tenant_verification', {
            hostname: location.hostname,
            status: err.status,
            message: this.tenantError,
          });
          return scope;
        });
      }
    })
  }

  initiateApp() {
    this.mixPanel.init('web-visitor');
    this.store.dispatch(new GlobalActions.GetGlobalSettings())
    this.store.dispatch(new AdsActions.GetAds())

    this.globalSettings$ = this.store.pipe(select(getGlobalSettings));

    /* Tenant verification (getTenantDetails() above) can succeed for a
       spoke hostname that's registered in the cockpit's CORS registry but
       whose actual business-backend API rejects it (e.g. hub_spoke_domain_
       enabled off there) -- global settings are essential for the app to
       render at all, so a failure here means this visitor genuinely can't
       use the site, same as a tenant-verification failure. Route it into
       the same "Direct access is not allowed" state instead of leaving the
       page half-loaded behind a raw toast (public-api.service.ts's own
       catchError already shows that toast; this is additive, not a
       replacement). */
    this.store.pipe(select(getGlobalSettingsError), takeUntil(this.destroyed$)).subscribe((error) => {
      if (error && !this.tenantError) {
        this.tenantError = error;
      }
    });

    combineLatest([
      this.globalSettings$,
      this.store.pipe(select(getPartnerBranding)),
    ]).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe(([res, partnerBranding]: [IGlobalSettings, IPartnerBranding]) => {
      if (res) {
        this.globalSettings = res;
        // this.titleService.setTitle(res.websiteName);

        // this.metaService.updateTag({ description: res.websiteDescription })

        console.log("Settingtinging", res)

        this.metaService.addTag({
          name: 'keywords',
          content: res.websiteKeywords
        });

        /* Spoke's own colors/favicon win whenever set -- falls back to the
           hub's tenant-wide branding for anything the spoke hasn't
           configured (SAN-386, per the governing feature's fallback rule). */
        const effectivePrimaryColor = partnerBranding?.colors?.primary || res.branding.colors.primary;
        const effectiveSecondaryColor = partnerBranding?.colors?.secondary || res.branding.colors.secondary;
        const effectiveFavicon = partnerBranding?.favicon || res.branding.favicon;
        const brandedSettings: IGlobalSettings = {
          ...res,
          branding: {
            ...res.branding,
            favicon: effectiveFavicon,
            colors: {
              ...res.branding.colors,
              primary: effectivePrimaryColor,
              secondary: effectiveSecondaryColor,
            },
          },
        };

        const r: any = document.querySelector(':root');

        // Create a function for setting a variable value
        function setTheme() {
          // Set the value of variable --blue to another value (in this case "lightblue")
          r.style.setProperty('--color-theme', effectivePrimaryColor);
          r.style.setProperty('--color-secondary', effectiveSecondaryColor);
          r.style.setProperty('--color-certificate', res.certificate.certificatePrimaryColor);
        }

        setTheme()
        // this.updateFavicon('https://images.unsplash.com/photo-1618042164219-62c820f10723?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=20');
        this.updateFavicon(res.imgKitUrl + effectiveFavicon);
        this.updateManifest(brandedSettings);
        this.updateThemeColor(brandedSettings);

        if (res.site.google_analytics) {
          this.injectGoogleAnalyticsScript(res.site.google_analytics);
        }

      }
    })

    // you can subscribe to WOW observable to react when an element is revealed
    this.wowSubscription = this.wowService.itemRevealed$.subscribe(
      (item: HTMLElement) => {
        // do whatever you want with revealed element
      });
    this.setLoggedInUserDetails();

    // this.formsManagementService.getFormsList().subscribe((res) => {
    //   console.log('getFormsList', res)
    // })
  }


  injectGoogleAnalyticsScript(code: string) {
    const script = document.createElement('script');
    script.async = true;
    script.nonce = 'mvrk6f5gnltrl06mhqbn6nq5qtlk'
    script.src = `https://www.googletagmanager.com/gtag/js?id=${code}`;

    const configScript = document.createElement('script');
    configScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${code}');
    `;

    document.head.appendChild(script);
    document.head.appendChild(configScript);
  }

  setLoggedInUserDetails(): void {
    this.getLoggedInUserDetails$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
      if (res?.userId) {
        this.store.dispatch(new NotificationsActions.SetNotificationsCount())
        this.notificationsCountInterval = setInterval(() => {
          // SAN-1429 (BRD §7.2, NFR-02) — notification centre on: no requests
          // while the tab is hidden; visibilityListener catches up on return.
          if (this.isNotificationCentreOn && document.hidden) return;
          this.store.dispatch(new NotificationsActions.SetNotificationsCount())
        }, 30000)
        document.addEventListener('visibilitychange', this.visibilityListener);
      } else {
        if (this.notificationsCountInterval) {
          clearInterval(this.notificationsCountInterval);
        }
        window.removeEventListener("storage", this.storageEventListner);
        document.removeEventListener('visibilitychange', this.visibilityListener);
      }
    })
  }

  get isNotificationCentreOn(): boolean {
    return this.brandDetails?.features?.notification_centre_enabled === true;
  }

  visibilityListener = () => {
    if (this.isNotificationCentreOn && !document.hidden) {
      this.store.dispatch(new NotificationsActions.SetNotificationsCount())
    }
  }

  ngOnDestroy() {
    // unsubscribe (if necessary) to WOW observable to prevent memory leaks
    this.wowSubscription.unsubscribe();
    this.destroyed$.next();
    this.destroyed$.complete();
    if (this.notificationsCountInterval) {
      clearInterval(this.notificationsCountInterval);
    }
    window.removeEventListener("storage", this.storageEventListner);
    document.removeEventListener('visibilitychange', this.visibilityListener);
    if (this.profileData) {
      this.socketService.leaveRoom(this.profileData.id as any)
    }
  }

  get maintenanceClosed() {
    return localStorage.getItem('maintainance_' + this.brandDetails.maintenance_mode.id) !== 'true'
  }

  handleCloseNotice() {
    localStorage.setItem('maintainance_' + this.brandDetails.maintenance_mode.id, 'true');
  }

  formatMaintenanceTime(time) {
    return moment.utc(time) // Parse as UTC
      .local()                 // Convert to local time
      .format('DD MMMM, YYYY hh:mm a'); // Format as desired
  }
}
